import { useContext } from 'react';
import { EmbeddedAuthContext } from '@/platform/authentication/EmbeddedAuthContext';

export function useEmbeddedAuth() {
  const context = useContext(EmbeddedAuthContext);

  if (!context) {
    throw new Error(
      'useEmbeddedAuth must be used within EmbeddedAuthProvider.',
    );
  }

  return context;
}
